import {
	QueryParamConfig,
	UrlUpdateType,
	decodeDelimitedArray,
	encodeDelimitedArray,
	useQueryParam
} from 'use-query-params';
import { CheckboxItem } from 'components/core/checkbox-group';
import { useAppSelector } from 'redux/store';
import { RadioButtonItem } from 'components/core/radio-button-group';

export const SCALE_QUERY_KEY = 'schaal';

type NewValueType<D> = D | ((latestValue: D) => D);

export type UseScaleReturn = {
	selectedScales: CheckboxItem[];
	selectedScalesParam: string | (string | null)[] | null | undefined;
	setSelectedScalesParam: (
		newValue: NewValueType<RadioButtonItem | null | undefined>,
		updateType?: UrlUpdateType | undefined
	) => void;
};

export const useScale = (): UseScaleReturn => {
	const { scales } = useAppSelector((state) => state.scales);

	const [selectedScalesParam, setSelectedScalesParam] = useQueryParam(SCALE_QUERY_KEY, ScaleArrayParam);
	const selectedScales = scales.filter((scale) => selectedScalesParam?.includes(String(scale.id)));

	return {
		selectedScales: selectedScales.map((scale) => ({
			id: scale.id,
			label: scale.name
		})),
		selectedScalesParam,
		setSelectedScalesParam
	};
};

export const ScaleArrayParam: QueryParamConfig<
	RadioButtonItem | null | undefined,
	string | (string | null)[] | null | undefined
> = {
	encode: (item) => {
		if (!item?.id) {
			return null;
		}

		return encodeDelimitedArray([item.id.split('-')[1]]);
	},
	decode: (param) => {
		return decodeDelimitedArray(param);
	}
};
